// RESULTS screen markup — from the prototype (a History link is added so a
// signed-in player can jump to their persisted play history). The hero medal
// icon (#resEmoji) is filled per tier by gameController from Medal.iconHtml.
import { icon } from '../ui/icons';

export const resultsHTML = /* html */ `
<div id="screenResults" class="results hidden">
  <div class="res-hero" id="resHero">
    <div class="res-emoji" id="resEmoji" aria-hidden="true"></div>
    <div class="lbl">Final bank</div>
    <div class="final money" id="finalBank">$0</div>
    <div class="res-medal" id="resMedal"></div>
    <div class="headline" id="resHeadline"></div>
    <div class="res-stats" id="resStats"></div>
  </div>
  <!-- Results must never read as an end stop (Eric 2026-08-16): the primary
       onward action sits at the TOP, before the breakdown scroll. -->
  <div class="cta res-continue">
    <button class="btn" id="resContinueBtn">Continue</button>
  </div>
  <div class="res-section-title hidden" id="resAchTitle">Achievements</div>
  <div class="res-ach hidden" id="resAch"></div>
  <div class="res-section-title">Round breakdown</div>
  <div class="res-list" id="resList"></div>
  <div class="res-guest hidden" id="resGuestCta">
    <div class="res-guest-txt" id="resGuestCtaText"></div>
    <button class="btn" id="resSaveScoreBtn">Create a free account</button>
    <div class="res-guest-saved hidden" id="resGuestSaved">Score saved.</div>
  </div>
  <div class="res-arcade hidden" id="resArcadeCta">
    <div class="res-arcade-txt">${icon('gamepad', 18)} <b>The Arcade is open.</b> Replay any mini-game from Home.</div>
    <button class="btn secondary" id="resArcadeBtn">Play the Arcade</button>
  </div>
  <!-- Journey Director's "now let's…" card (populated by renderJourneyResults) -->
  <div id="resJourney" class="pilgrimage-card res-journey hidden"></div>
  <div class="cta">
    <button class="btn" id="playAgainBtn">Play again</button>
    <button class="btn secondary hidden" id="resultsHistoryBtn" style="margin-top:12px;">View history</button>
  </div>
</div>`;
